<script>
    export let name;
    export let heading;
    export let options;
    export let current;

    import { L } from './l18n';
    import { specification, uiLang } from './store';
    import { baseUrl, optionUrl } from './url';
    import { quintOut } from 'svelte/easing';
    import { slide } from 'svelte/transition';

    let expanded = !!current;

    function toggle(event) {
        event.preventDefault();
        expanded = !expanded;
    }
</script>

<style>
    h3 {
        border-bottom: 1px solid #ddd;
        padding-bottom: 0.2rem;
        position: relative;
    }

    ol {
        list-style: none;
        margin: 0 !important;
        max-height: 310px;
        overflow-y: auto;
        padding: 0 0 0 1.25rem;
    }

    li {
        list-style: none;
        margin-bottom: 0.25rem;
    }

    a:visited {
        color: #222;
    }

    .link {
        color: #222;
        font-weight: 400;
        text-decoration: none;
    }

    .link:hover {
        text-decoration: underline;
    }

    .current .link {
        font-weight: 700;
        position: relative;
    }

    .toggle {
        color: #999 !important;
        display: block;
        font-size: 1rem !important;
        font-weight: 700 !important;
        width: 100%;
    }

    .toggle:hover,
    .toggle:focus {
        color: #666 !important;
        text-decoration: none;
    }

    .toggle::after {
        content: '+';
        float: right;
        line-height: 1 !important;
    }

    .toggle.expanded::after {
        content: '-';
    }
</style>

{#if !!options && options.length > 0}
    <h3>
        <a on:click={toggle}
            aria-controls={`menu-${name}`}
            aria-expanded={expanded} 
            aria-pressed={expanded}
            class=toggle
            class:expanded
            href
            role="button">
            {heading}
        </a>
    </h3>
    {#if expanded}
        <ol id={`menu-${name}`} transition:slide={{ duration: 500, easing: quintOut }}>
            <li class:current={!current}>
                <a class="link" href={baseUrl(name)}>{L(`en: don't filter | ga: ná scag`)}</a>
            </li>
            {#each options as option}
                <li class:current={current===option.id}>
                    <a class="link" href={optionUrl(name, option.id)}>{$uiLang === 'ga' ? option.ga : option.en}</a>
                </li>
            {/each}
        </ol>
    {/if}
{/if}